import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Avatar } from '@heroui/react';
import { ContentWrapper } from '@/widgets/ContentWrapper';
import { useGetTeacherRequestDetailQuery } from '@/entities/TeacherRequests';
import { AppButton } from '@/shared/ui/AppButton';
import { ProfileRequestShell } from '../components/ProfileRequestShell';
import { RequestAttachmentList } from '../components/RequestAttachmentList';
import { TeacherRequestEditForm } from '../components/TeacherRequestEditForm';
import {
  TEACHER_REQUEST_REASON_LABELS,
  TEACHER_REQUEST_STATUS_CLASSES,
  TEACHER_REQUEST_STATUS_LABELS,
  formatRequestDateTime,
} from '../../components/TeacherRequests/teacherRequestUi';

export const TeacherRequestDetailView = () => {
  const { requestId } = useParams();
  const parsedRequestId = Number(requestId);
  const [isEditing, setIsEditing] = useState(false);
  const { data: request, isLoading, error } = useGetTeacherRequestDetailQuery(parsedRequestId, {
    skip: !parsedRequestId,
  });

  return (
    <ProfileRequestShell title="Request">
      <ContentWrapper isLoading={isLoading} isError={!!error || !parsedRequestId} className="max-w-[560px]">
        {request && (
          <div className="flex max-w-[560px] flex-col gap-8">
            <div className="flex items-center gap-6">
              <h2 className="text-[36px] font-medium">Request</h2>
              <span className={`rounded px-2 py-1 text-sm font-medium ${TEACHER_REQUEST_STATUS_CLASSES[request.status]}`}>
                {TEACHER_REQUEST_STATUS_LABELS[request.status]}
              </span>
              {/*
                Сервер разрешает правку, пока заявка в статусе new — то же условие, при
                котором в списке заявок показывается корзина.
              */}
              {request.status === 'new' && !isEditing && (
                <AppButton color="white" height={40} onPress={() => setIsEditing(true)}>
                  Edit
                </AppButton>
              )}
            </div>

            {isEditing ? (
              <TeacherRequestEditForm request={request} onDone={() => setIsEditing(false)} />
            ) : (
              <div className="flex flex-col gap-3">
                <h3 className="text-xl font-semibold">{TEACHER_REQUEST_REASON_LABELS[request.reason]}</h3>
                <p className="text-base leading-[140%]">{request.staffComment}</p>
                <RequestAttachmentList attachments={request.staffAttachments} />
              </div>
            )}

            {(request.adminComment || request.adminAttachments.length || request.resolvedBy) && (
              <div className="mt-4 flex flex-col gap-5 rounded-xl bg-[#F4F6FF] p-6">
                <h3 className="text-base font-semibold">Decision</h3>
                {request.resolvedBy && (
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <Avatar src={request.resolvedBy.avatar ?? undefined} className="h-10 w-10" />
                      <span className="text-base font-medium">
                        {`${request.resolvedBy.firstName} ${request.resolvedBy.lastName}`.trim() ||
                          request.resolvedBy.username}
                      </span>
                    </div>
                    <span className="text-sm text-grey-secondary">Sent: {formatRequestDateTime(request.resolvedAt)}</span>
                  </div>
                )}
                {request.adminComment && <p className="text-base leading-[140%]">{request.adminComment}</p>}
                <RequestAttachmentList attachments={request.adminAttachments} />
              </div>
            )}
          </div>
        )}
      </ContentWrapper>
    </ProfileRequestShell>
  );
};
